import { render, staticRenderFns } from "./supports.vue?vue&type=template&id=c73c9c2e"
import script from "./supports.vue?vue&type=script&lang=js"
export * from "./supports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports